import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../../zodios/client";

export const useGetV4OrgReportOptions = () => {
  return queryOptions({
    queryKey: [{ entity: "V4OrgReportOptions" }],
    queryFn: async () => await apiClient.getV4OrgReportOptions({}),
    placeholderData: keepPreviousData,
  });
};
